<template>
    <div :class="$style.root">
        <!-- <img src="../../../assets/01.jpg" alt=""> -->
        <a-carousel :autoplay="autoplay" arrows>
            <div
                slot="prevArrow"
                class="custom-slick-arrow"
                style="left: 1px; z-index: 999;">
                <a-icon type="left" :style="{ fontSize: '40px', color: '#fff',zindex:'99' }" />
            </div>
            <div slot="nextArrow" class="custom-slick-arrow" style="right: 15px;">
                <a-icon type="right" :style="{ fontSize: '40px', color: '#fff',marginRight:'20px' }" />
            </div>

            <div @click="torouter(0)">
                <h3><img class="img-list" :src="imageUrl4" @error="error4" alt=""></h3>
            </div>
            <div @click="torouter(1)">
                <h3><img class="img-list" :src="imageUrl5" @error="error5" alt=""></h3>
            </div>
            <div @click="torouter(2)">
                <h3><img class="img-list" :src="imageUrl6" @error="error6" alt=""></h3>
            </div>
            <div @click="torouter(3)">
                <h3><img class="img-list" :src="imageUrl7" @error="error7" alt=""></h3>
            </div>
        </a-carousel>
    </div>
</template>
<script>
    import { mapActions, mapState } from 'vuex';

    const imageUrl2 = require('../../../assets/04.png');

    const date = new Date();
    const URL = `http://${window.location.host.split(':')[0]}:8000/`;
    export default {
        name: 'BannerView',
        data() {
            return {
                autoplay: true,
                bannerList: [],
                URL,
                date,
                imageUrl4: require('../../../assets/04.png'),
                imageUrl5: require('../../../assets/05.png'),
                imageUrl6: require('../../../assets/06.png'),
                imageUrl7: require('../../../assets/07.png'),
                errorImage4: ` this.src=" ${require('../../../assets/04.png')} " `,
                errorImage5: ` this.src=" ${require('../../../assets/05.png')} " `,
                errorImage6: ` this.src=" ${require('../../../assets/06.png')} " `,
                errorImage7: ` this.src=" ${require('../../../assets/07.png')} " `,
            };
        },
        
        computed: {
            ...mapState('indexView'),
            ...mapState(['userInfo']),
        },
        mounted() {
            this.handleLoadBannerList();
            console.log('4');
            console.log(this.bannerList);
            this.imageUrl4 = `${URL}files/banner/4.png` ? `${URL}files/banner/4.png?${date}` : require('../../../assets/04.png');
            this.imageUrl5 = `${URL}files/banner/5.png` ? `${URL}files/banner/5.png?${date}` : require('../../../assets/04.png');
            this.imageUrl6 = `${URL}files/banner/6.png` ? `${URL}files/banner/6.png?${date}` : require('../../../assets/04.png');
            this.imageUrl7 = `${URL}files/banner/7.png` ? `${URL}files/banner/7.png?${date}` : require('../../../assets/07.png');
        },
        methods: {
            ...mapActions('indexView', ['getBannerList']),

            // 加载列表
            handleLoadBannerList() {
                console.log('4');
                // 打印请求参数
                let queries = {};
                // const _this = this;
                const orgId = this.userInfo.org_id || '';

                queries = {
                    orgId: orgId || '',
                };
                if (!this.userInfo.user_name) {
                    delete queries.orgId;
                }
                this
                    .getBannerList(queries)
                    .then((res) => {
                        this.spinning = false;
                        this.bannerList = res.data;
                        console.log(this.bannerList);
                    })
                    .catch(({ message }) => {
                        if (message) this.$message.error(message);
                        this.spinning = false;
                    });
            },
            torouter(e) {
                const aa = this.bannerList[e].banner_link;
                if (!aa) {
                    return;
                }
                if (!this.userInfo.org_id) {
                    this.$message.error('请先登录');
                    return;
                }
                window.location.href = aa;
            },
            error4() {
                console.log('4');
                this.imageUrl4 = require('../../../assets/04.png');
            },
            error5() {
                console.log('5');
                this.imageUrl5 = require('../../../assets/05.png');
            },
            error6() {
                console.log('121212');
                this.imageUrl6 = require('../../../assets/05.png');
            },
            error7() {
                this.imageUrl7 = require('../../../assets/07.png');
            },
        },
    };
</script>
<style lang="less" module>
    .root {
        max-width: 1180px;
        height: 400px;
        overflow: hidden;
        margin: 20px auto;

        :global {
            /* For demo */
            .ant-carousel .slick-slide {
                text-align: center;
                height: 400px;
                line-height: 160px;
                width: 199%;
                // background: #364d79;
                overflow: hidden;
                max-width: 1180px;
            }

            .ant-carousel .custom-slick-arrow {
                width: 25px;
                height: 25px;
                font-size: 25px;
                color: #fff;
                // background-color: rgba(31, 45, 61, 0.11);

                /* opacity: 0.3; */
            }

            .ant-carousel .custom-slick-arrow::before {
                display: none;
            }

            .ant-carousel .custom-slick-arrow:hover {
                opacity: 0.5;
            }

            .img-list {
                width: 100%;
                height: 400px;
                z-index: 10;
                border-radius: 15px;
            }
        }
    }
</style>
